module.exports = __webpack_public_path__ + "img/08_maska_mazok_3.e41ab16.svg";